module.exports = __webpack_public_path__ + "static/humainly-logo-2f7c7d14dfe578b7f00729b4019d016c.png";